import type { IQABundle } from '../model/types';

const BASE_URL = import.meta.env.BASE_URL;

export async function loadQuestions(language: string, catalogId: string): Promise<IQABundle> {
  const [questionsRes, answersRes] = await Promise.all([
    fetch(`${BASE_URL}catalog/${catalogId}/${language}.json`),
    fetch(`${BASE_URL}catalog/${catalogId}/answers.json`),
  ]);

  if (!questionsRes.ok) {
    throw new Error(`Failed to load questions: ${questionsRes.statusText}`);
  }
  if (!answersRes.ok) {
    throw new Error(`Failed to load answers: ${answersRes.statusText}`);
  }

  const [questions, answers] = await Promise.all([
    questionsRes.json(),
    answersRes.json(),
  ]);

  return { questions, answers };
}

export interface CatalogMetadata {
  name: string;
  version: string;
  languages: string[];
  questionCount: number;
}

export async function loadCatalogMetadata(catalogId: string): Promise<CatalogMetadata> {
  const res = await fetch(`${BASE_URL}catalog/${catalogId}/metadata.json`);
  if (!res.ok) {
    throw new Error(`Failed to load catalog metadata: ${res.statusText}`);
  }
  return res.json();
}

export async function loadCatalogIndex(): Promise<Array<CatalogMetadata & { id: string }>> {
  const res = await fetch(`${BASE_URL}catalog/index.json`);
  if (!res.ok) {
    throw new Error(`Failed to load catalog index: ${res.statusText}`);
  }
  return res.json();
}
